// @flow
import { BoundingFactory } from '../helpers';

export type TDataForTranslateTooltip = {| text: ?string, ...$Call<typeof BoundingFactory> |};

export const defaultDataForTranslateTooltip: TDataForTranslateTooltip = {
  text: null,
  ...BoundingFactory(),
};
